import {autoImplement, momentFromDateAndTime} from '@/util';
import {Moment} from 'moment';


export interface ApiTour {
  Tournr: number;
  Fahrzeugnr: number;
  KfzKennzeichen: string;
  Tourdatumvon: string;
  Tourstart: null | string;
  Tourdatumbis: string;
  Tourende: null | string;
}

export interface TourInterface extends ApiTour {
  TourdatumvonParsed: Moment;
  TourdatumbisParsed: Moment;
}

export default class Tour extends autoImplement<TourInterface>() {
  static fromApi(apiTour: ApiTour): Tour {
    return new Tour({
      ...apiTour,
      TourdatumvonParsed: momentFromDateAndTime(apiTour.Tourdatumvon, apiTour.Tourstart),
      TourdatumbisParsed: momentFromDateAndTime(apiTour.Tourdatumbis, apiTour.Tourende),
    });
  }
}
